<div class="sidebar w-40" data-color="white" data-active-color="danger">
  <div class="logo text-center">
    <span class="simple-text logo-mini">
      <div class="logo-image-small">
        <img src="./assets/img/eletronorte-logo.jpg" style="width: 100px" />
      </div>
    </span>
    <span
      class="simple-text logo-normal text-center"
      style="padding-top: 5px; padding-bottom: 0px"
    >
      ELETRONORTE
    </span>
    <span
      class="simple-text text-center"
      data-color="white"
      style="padding-top: 5px; padding-bottom: 0px; font-size: 10px"
    >
      EPatrimonio
    </span>
  </div>
  <div class="sidebar-wrapper w-100">
    <ul class="nav">
      <li routerLinkActive="active" *ngFor="let item of menuItems">
        <a [routerLink]="[item.path]" routerLinkActive="active">
          <i class="text-icon {{ item.icon }}"></i>
          <p class="text mw-100">{{item.nome}}</p>
        </a>
      </li>
    </ul>
    <div class="d-flex justify-content-end">
      <span
        class="simple-text logo-normal text-end"
        style="padding-right: 10px;color:#6c757d;font-size: 12px;"
      >
        1.0.3
      </span>
    </div>
  </div>
</div>
